import * as React from "react";
import { Link } from "react-router-dom";
import menu from "./menu";
import styles from "./styles.module.scss";

const MenuBar = () => {
  return (
    <div className={styles["menu-bar"]}>
      <ul className={styles["menu-list"]}>
        {menu.map(({ name, root, icon }) => {
          const Icon = icon;
          return (
            <li className={styles["nav-item"]} key={name}>
              <Link className={styles.link} to={root}>
                <Icon />
                {name}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default MenuBar;
